import React, { useEffect, useState } from 'react'
import api from '../../../api'
import { Work, WorkShift } from '../../Shared/common_defs'
import Loading from '../../Shared/loading'
import WorkerBasicInfo from './WorkerBasicInfo'

interface Props {
  shift: WorkShift
  fetchWorkStats: () => void
}

const WorkerList = ({ shift, fetchWorkStats }: Props) => {
  // grab list of work associated with this shift
  // for each work display WorkerBasicInfo
  const [fetchingWorkers, setFetchingWorkers] = useState(false)
  const [workItems, setWorkItems] = useState<(Work | null)[]>([])
  const needsWorkers =
    (shift.workersNeeded ?? 0) + (shift.numCushionWorkersNeeded ?? 0) >
    (shift.numWorkersScheduled ?? 0) +
      (shift.numWorkersStarted ?? 0) +
      (shift.numWorkersFinished ?? 0)

  useEffect(() => {
    // componentDidMount - use the work item we already asked for in shift query
    setWorkItems(sortWorkers(shift.work))
  }, [])

  useEffect(() => {
    // when the shift prop changes (i.e. worker stats at level above changed, query again for updated info on our workers)
    fetchWorkers(true)
  }, [shift])

  // fetchWorkers used in actions in child components that require a refresh of the top level worker data
  const fetchWorkers = (showLoading?: boolean) => {
    if (showLoading) {
      setFetchingWorkers(true)
    }
    api
      .post('/admin/graphql_dispatch/worker_list_56e16288', {
        shiftId: shift.id,
      })
      .then((response) => {
        const workData = response.data.data.admin.shift.work
        if (workData) {
          setWorkItems(sortWorkers(workData))
        }
        setFetchingWorkers(false)
      })
      .catch(() => {
        setFetchingWorkers(false)
      })
  }

  if (fetchingWorkers) {
    return <Loading type="button" />
  }

  if (!workItems || workItems.length === 0) {
    return <p>Could not find workers for this shift.</p>
  }

  return workItems
    .filter((work): work is Work => work !== null)
    .map((work) => (
      <WorkerBasicInfo
        key={work.id}
        work={work}
        shift={shift}
        needsWorkers={needsWorkers}
        fetchWorkStats={fetchWorkStats}
        fetchWorkers={fetchWorkers}
      />
    ))
}

export default WorkerList

const sortWorkers = (people): Array<Work | null> => {
  const localArray = [...people]
  localArray.sort(function (personA, personB) {
    const textA = personA.status
    const textB = personB.status
    return textA < textB ? -1 : textA > textB ? 1 : 0
  })

  return localArray
}
